<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card p-fluid">
        <h4>Enrol Quotes</h4>
        <p>
          Paste quote numbers to start follow-up emails for them. Put one per line, or separate
          them with commas or spaces.
        </p>

        <div class="p-field">
          <label for="quoteNos">Quote numbers</label>
          <Textarea id="quoteNos" v-model="text" rows="8" :autoResize="true" :placeholder="'Q9150260\nQ9150261'" />
          <small>{{ numbers.length }} quote number{{ numbers.length === 1 ? '' : 's' }}</small>
        </div>

        <div class="p-d-flex p-jc-end">
          <Button id="enrolQuotes" label="Enrol" icon="pi pi-check" style="width: auto"
            :disabled="sending || numbers.length === 0" @click="enrol" />
        </div>

        <div v-if="results.length" class="p-mt-4">
          <h5>Results</h5>
          <DataTable :value="results" class="p-datatable-striped p-datatable-sm p-datatable-gridlines" dataKey="quoteNo">
            <Column field="quoteNo" header="Quote number" headerStyle="width: 12em" />
            <Column field="result" header="Result" />
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FollowupService, { errorMessage } from '@/service/FollowupService'
import { splitQuoteNumbers } from './quoteNumbers'

export default {
  data: () => ({
    followupService: new FollowupService(),
    text: '',
    results: [],
    sending: false
  }),
  computed: {
    numbers() {
      return splitQuoteNumbers(this.text)
    }
  },
  methods: {
    enrol() {
      var nos = this.numbers
      if (!nos.length) return Promise.resolve()
      this.sending = true
      return this.followupService.enrolList(nos)
        .then(data => {
          this.results = Array.isArray(data) ? data : []
          var enrolled = this.results.filter(r => r && r.result === 'Enrolled').length
          this.$toast.add({
            severity: 'success',
            summary: 'Done',
            detail: enrolled + ' of ' + nos.length + ' enrolled. See the results below.',
            life: 5000
          })
        })
        .catch(err => {
          this.$toast.add({
            severity: 'error',
            summary: 'Not enrolled',
            detail: errorMessage(err, 'The quotes could not be enrolled.'),
            life: 5000
          })
        })
        .finally(() => { this.sending = false })
    }
  }
}
</script>

<style></style>
